import React from 'react';
import { PiDotsThreeVerticalBold } from "react-icons/pi";

const Dropdown = ({ active, onClick, options }) => {
    return (
        <div className="relative">
            <button className="p-1 rounded" onClick={onClick}>
                <PiDotsThreeVerticalBold className="h-5 w-5 text-black" />
            </button>
            {active && (
                <div className="absolute right-0 mt-2 w-28 bg-white rounded-[1.75rem] shadow-lg z-50 border-t border-b border-r border-solid border-bordercolor">
                    <div className="grid grid-rows-[auto,1px,auto,1px,auto]">
                        {options.map((option, index) => (
                            <React.Fragment key={index}>
                                <button
                                    className="font-quicksand text-sm font-semibold w-full px-4 py-2 text-normalGray hover:bg-buttoncolor rounded-sm hover:text-black text-center"
                                    onClick={option.onClick}
                                >
                                    {option.label}
                                </button>
                                {index < options.length - 1 && (
                                    <div className="border-t border-bordercolor border-solid mx-4"></div>
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Dropdown;
 